import { confirmDestructive } from './confirmDestructive';

import type { HookAPI } from 'antd/es/modal/useModal';
import type { TFunction } from 'i18next';

/**
 * The one "leave with unsaved changes?" confirm — shared by modals, drawers,
 * and route blockers so the copy, buttons, and styling never drift.
 */
export function confirmUnsavedChanges(
  modal: HookAPI,
  t: TFunction,
  { onOk, onCancel }: { onOk: () => void; onCancel?: () => void },
) {
  return confirmDestructive(modal, {
    title: t('UNSAVED_CHANGES_TITLE'),
    content: t('FORM_CLOSE_CONFIRMATION'),
    okText: t('DISCARD_CHANGES'),
    cancelText: t('KEEP_EDITING'),
    onOk,
    onCancel,
  });
}
